import { Component, OnInit, Output } from '@angular/core';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Platform, NavController, MenuController } from '@ionic/angular';
import { EventEmitter } from 'events';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { LangactionService } from 'src/app/service/lang/langaction.service';

@Component({
  selector: 'app-sidenavigation',
  templateUrl: './sidenavigation.component.html',
  styleUrls: ['./sidenavigation.component.scss'],
})
export class SidenavigationComponent implements OnInit {

  langcontext: any;
  submenu: any;
  context: any;
  role: any;
  profilerequest: any;
  profilename: any;
  profileimg: any;
  mobileno: any = 0;
  userInfo: any;
  @Output() onFilter: EventEmitter = new EventEmitter();

  constructor(public langAction: LangactionService, public menu: MenuController, public api: RestapiService, public action: ActionlistenService, public navCtrl: NavController, public cmndef: CommonDefinitionService, public cmndeclaration: CommonDeclarationService, public platform: Platform) {
    // this.platform.ready().then(() => {
    //   this.init();
    //   this.getUpdateDetails();
    //   this.langAction.listen().subscribe((msg: any) => {
    //     console.log(msg);
    //     this.init();
    //   });
    // });
  }

  init() {
    let prof: any
    this.role = localStorage.role;
    if (this.cmndeclaration.LanguageJson) {
      this.context = this.cmndeclaration.LanguageJson.pages[0];
      this.langcontext = this.cmndeclaration.LanguageJson.pages[0]['Sidemenu'];
      this.submenu = this.cmndeclaration.LanguageJson.pages[0]['vassubmenu'];
    } else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.context = this.cmndeclaration.LanguageJson['pages'][0];
      this.langcontext = this.cmndeclaration.LanguageJson['pages'][0].Sidemenu;
      this.submenu = this.cmndeclaration.LanguageJson['pages'][0].vassubmenu;
    }

    this.cmndeclaration.getstoreProcess("profile").then(data => {
      if (data == undefined || data == null) {
        this.profileimg = "assets/images/profile_icon.png";
        this.profilename = "Metlife"
      } else {
        prof = data;
        if (prof.profilePicture == "" || prof.profilePicture == null)
          this.profileimg = "assets/images/profile_icon.png";
        else
          this.profileimg = "data:image/jpeg;base64," + prof.profilePicture
        this.profilename = prof.displayName;
        this.cmndeclaration.profileImg = this.profileimg;
      }
    }, err => {
      console.log(err);
    })
  }

  ngOnInit() {
  }


  getUpdateDetails() {
    let res: any
    if (localStorage.user.indexOf("@") == -1) {
      this.mobileno = localStorage.user;
    }

    this.profilerequest = {
      "mobileNo": this.mobileno,
      "requestType": "getProfileData",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }
    console.log("here is calling")
    console.log(this.profilerequest)
    this.api.postapi("updateDetails", this.profilerequest).then(data => {
      this.cmndeclaration.storeProcess(data, "profile");
      res = data
      if (res.displayName == "" || res.displayName == undefined)
        this.profilename = "User"
      else
        this.profilename = res.displayName;

      if (res.mobileNo != "0") {
        this.mobileno = res.mobileNo;
        localStorage.user = this.mobileno
      }
      
      if (res.profilePicture == "" || res.profilePicture == null)
        this.profileimg = "assets/images/profile_icon.png";
      else
        this.profileimg = "data:image/jpeg;base64," + res.profilePicture;
      this.cmndeclaration.profileImg = this.profileimg;

      this.api.postapi("getProfiletMenu", {}).then(data => {
        console.log(data);
        res = data;
        this.cmndeclaration.storeProcess(res.menu, "profileMenu");
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position: Position) => {
            if (position) {
              this.profilerequest = {
                "latitude": String(position.coords.latitude),
                "longitude": String(position.coords.longitude),
                "requestType": "LOCATION",
                "userSessionID": localStorage.userSessionID,
                "userChatSessionId": localStorage.userChatSessionId,
              }
              this.api.postapi("updateDetails", this.profilerequest).then(data => {

              }, err => {
                console.log(err);
              })
            }
          },
            (error: PositionError) => console.log(error));
        } else {
          console.log("Geolocation is not supported by this browser.");
        }
      }, err => {
        console.log(err);
      });
    }, err => {
      console.log(err);
    })

  }


  checkfunction(flg: any, title: any) {
    let reJson: any
    let profileName: any;
    let profile: any;
    this.api.clickenventcap(title);
    if (flg == 'reminder') {
        this.cmndeclaration.ChatpushData = this.context.va.setremaindermsg;
    } else if (flg == 'logout') {
      this.cmndef.showConfirmAlert(this.context.alerts.logout, this.context.alerts.logoutConfirmation, flg, this.context.alerts.yes, this.context.alerts.no);
    } else if (flg == "watchVideo") {
      window.open('https://youtu.be/GEA7e84mL3k', "_system");
      // let req = {
      //   "userSessionID": localStorage.userSessionID,
      //   "userChatSessionID": localStorage.userChatSessionId,
      // };
      // this.cmndef.loaderstart();
      // this.api.postapi("getVideoList",req).then(async (data: any)=>{
      //   console.log(data);
      //   console.log(data.videoDetls.length)
      //   await this.cmndef.loaderend();
      //   if(data.videoDetls.length >0){
      //     this.cmndeclaration.youtubelist = data.videoDetls;
      //     sessionStorage.CurrentPage = "/va/youtubevideo"
      //     this.navCtrl.navigateForward("/va/youtubevideo")
      //   }
      // },async err=>{
      //   console.log(err);
      //   await this.cmndef.loaderend();
      // })
    } else if (flg == 'feedback') {
      this.cmndeclaration.getstoreProcess("profile").then(data => {
        console.log(data);
        profile = data;
        if (profile.displayName == undefined || profile.displayName == "")
          profileName = this.context.va.hilabel + " User. " + this.context.va.feedbackmsg
        else
          profileName = this.context.va.hilabel + " " + profile.displayName + ". " + this.context.va.feedbackmsg
        this.cmndeclaration.functionCall = 'feedback';
        this.cmndeclaration.parampassing = profileName;
        }, err => {
          console.log("err");
        })
    } else if (flg == "faqs") {
      sessionStorage.CurrentPage = "/va/faqs";
      this.navCtrl.navigateForward("/va/faqs")
    } else if (flg == "changelanguage") {
      sessionStorage.CurrentPage = "/changelanguage"
      this.navCtrl.navigateForward("/changelanguage")
    } else if (flg == "intemateclaim") {
      sessionStorage.CurrentPage = "/claimlogin"
      this.navCtrl.navigateForward("/claimlogin")
    } else if (flg == "changePassword") {
      this.cmndeclaration.getstoreProcess("profile").then(resq => {
        this.userInfo = resq;
        console.log("userdetails", this.userInfo);
        var data = {
          "actionType": "OTPREQUEST",
          "userSessionID": localStorage.userSessionID,
          "userChatSessionID": localStorage.userChatSessionId
        };
        this.api.postapi("otpRequest", data).then(res => {
          if (res['responseCode'] == "001" || res['status'] == "Success") {
            this.userInfo.state = res['state'];
            localStorage.state = res['state'];
            this.cmndeclaration.storeProcess(this.userInfo,"profile");
            this.cmndef.previousPage = "";
            sessionStorage.CurrentPage = "/verifyOtpPassword"
            this.navCtrl.navigateForward("/verifyOtpPassword")
          }
        }, err => {
          console.log(err);
        })
      })
    } else if (flg == "settings") {
      sessionStorage.CurrentPage = "/va/setting"
      this.navCtrl.navigateForward("/va/setting")
    } else if (flg == "teledoctorconsultation") {
      this.cmndef.selectedVAS = "teledoctor";
      this.cmndef.visitedPage = "teledoctorconsultation";
      sessionStorage.CurrentPage = "/va/vasdetails"
      this.navCtrl.navigateForward("/va/vasdetails")
    } else if (flg == "healthnwellness") {
      this.cmndef.selectedVAS = "health";
      this.cmndef.visitedPage = "healthnwellness";
      sessionStorage.CurrentPage = "/va/vasdetails"
      this.navCtrl.navigateForward("/va/vasdetails")
    } else if (flg == "vasfaq") {
      sessionStorage.CurrentPage = "/va/vasfaq";
      this.navCtrl.navigateForward("/va/vasfaq")
    } else if (flg == "callCustomercare") {
      this.cmndef.showConfirmAlert("", this.cmndeclaration.LanguageJson.pages[0].alerts.callCustomercarePrompt, "customercare", this.cmndeclaration.LanguageJson.pages[0].alerts.yes, this.cmndeclaration.LanguageJson.pages[0].alerts.no)
    } else if (flg == "rate") {
      this.cmndef.showConfirmAlert(this.cmndeclaration.LanguageJson.pages[0].alerts.appRateTitle, this.cmndeclaration.LanguageJson.pages[0].alerts.appRateDescription, "rateus", this.cmndeclaration.LanguageJson.pages[0].alerts.appRateNow, this.cmndeclaration.LanguageJson.pages[0].alerts.appRateNoThanks)
    } else if (flg == "appsupport") {
      this.cmndef.presentAlert(this.cmndeclaration.LanguageJson.pages[0].alerts.appsupport, this.cmndeclaration.LanguageJson.pages[0].alerts.appSupportdesc, "");
    } else if (flg == "prospectRegister") {
      sessionStorage.CurrentPage = "/prospregister";
      this.navCtrl.navigateRoot("/prospregister");
    } else if (flg == "prospectLogin") {
      this.cmndef.showConfirmAlert("", this.cmndeclaration.LanguageJson.pages[0].alerts.prospectLoginPromptMessage, "prospectLogin", this.cmndeclaration.LanguageJson.pages[0].alerts.yes, this.cmndeclaration.LanguageJson.pages[0].alerts.no);
    }
  }

  redirectprofilePage() {
    sessionStorage.CurrentPage = "/profile"
    this.api.clickenventcap("redirectProfilePage");
    this.menu.close();
    this.navCtrl.navigateForward("/profile");
  }
}
